import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Form } from "react-bootstrap";
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import LoadingOverlay from "react-loading-overlay";
import "./addlink.css";
import { AddIcon } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import { adminConfig } from "../../../utils/adminConfig";

const AddLinkPart = () => {
  const [link, setLink] = useState({
    id: "",
    link: "",
    tripValet: true,
    tripValetIncentive: true,
    active: true,
  });
  const [loading, setLoading] = useState(false);

  const addLink = () => {
    setLoading(true);

    axios
      .patch(`/update-link`, link, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          message.success("link added");
          setLink({
            id: "",
            link: "",
          });
          getLink();
          setLoading(false);
        } else {
          message.error("failed fetching member");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [inactlinks, setINACTLinks] = useState([]);
  const getLink = () => {
    setLoading(true);

    axios
      .get(`/get-inactive-links`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setINACTLinks(res.data.data);
          // setPagination(res.data.pagination);
          // console.log("pagination", res.data.pagination);
          setLoading(false);
          message.success("link fetched");
        } else {
          message.error("failed fetching ");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getLink();
  }, []);

  return (
    // <div>
    <LoadingOverlay active={loading} spinner text="loading...">
      {/* <HeaderPart />
        <div className="main_cont">
          <LeftpanelAdmin /> */}
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            {/* <h2>Hello, Admin!</h2> */}
            <div className="text_field_partts">
              <Form>
                {inactlinks.length > 0 &&
                  inactlinks.map((link, key) => {
                    return (
                      <Row className="form_row" key={key}>
                        <Col lg="10" md="12" sm="12">
                          <Row>
                            <Col lg="8" md="12">
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicEmail"
                              >
                                <Form.Label>
                                  Please paste the link in this textfield for{" "}
                                  <b>{link.name}</b>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  onChange={(e) => {
                                    setLink({
                                      id: link._id,
                                      link: e.target.value,
                                    });
                                  }}
                                  placeholder="Enter link"
                                  className="text_link"
                                />
                              </Form.Group>
                            </Col>
                            <Col lg="4" md="12">
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicEmail"
                              >
                                <Form.Label> Domain</Form.Label>
                                <Form.Control
                                  as="label"
                                  className="text_link bulk_select"
                                >
                                  {link.portal}
                                </Form.Control>
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg="2" md="12" sm="12">
                          <button
                            type="button"
                            className="add_but"
                            onClick={addLink}
                          >
                            <span className="add_iconnn">
                              <img src={AddIcon} alt="" />
                            </span>
                            Add
                          </button>
                        </Col>
                      </Row>
                    );
                  })}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Shopping & Entertainment</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row>

                <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>My Account</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row> */}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Get paid to refer a friend</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row> */}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Calendar of Events</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row>  */}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Escape Trips</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row> */}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Affiliate Dashboard </b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row>  */}

                {/* <Row className="form_row">
                  <Col lg="10" md="12" sm="12">
                    <Row>
                      <Col lg="8" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            Please paste the link in this textfield for{" "}
                            <b>Training Videos</b>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter link"
                            className="text_link"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Please Select Domain</Form.Label>
                          <Form.Control
                            as="select"
                            className="text_link bulk_select"
                          >
                            <option>Select Domain</option>
                            <option>Tripvalet Incentives</option>
                            <option>Tripvalet</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="2" md="12" sm="12">
                    <button type="submit" className="add_but">
                      <span className="add_iconnn">
                        <img src={AddIcon} alt="" />
                      </span>
                      Add
                    </button>
                  </Col>
                  {/* <Col lg="2" md="12" sm="12">
                    <button type="submit" className="del_but">
                      <span className="add_iconnn">
                        <img src={DeleteIcon} alt="" />
                      </span>
                      Delete
                    </button>
                  </Col> */}
                {/* </Row> */}
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </LoadingOverlay>
    //  </div>
  );
};

export default AddLinkPart;
